<template>
	<div class="mine-container flex-row-as-jc">
		<div class="mine-container-lt flex-col-ac-js">
			<div class="user-profile flex-col-ac-js">
				<div class="avatar-circle">
					<div class="avatar-inner"></div>
				</div>
				<div class="user-info">
					<h2 class="user-name">用户{{ phone ? phone.slice(-4) : '0000' }}</h2>
					<p class="user-phone">{{phone ? phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : '****'}}</p>
				</div>

				<div class="tab-buttons flex-col-ac-js">
					<button class="tab-btn" :class="{ active: activeTab === 'upvote' }"
						@click="switchTab('upvote')">我点赞的</button>
					<button class="tab-btn" :class="{ active: activeTab === 'browse' }"
						@click="switchTab('browse')">我浏览的</button>
				</div>
			</div>
			<button class="logout-btn" @click="handleLogout">退出账户</button>
		</div>
		<div class="mine-container-rt flex-col-ac-js">
			<div class="data-tip" v-if="activeTab === 'browse'">
				系统只保留7天内的浏览记录
			</div>
			<div class="list-grid" v-if="articleList.length">
				<ArticleCard v-for="article in articleList" :key="article.articleId" :article="article" :aspect-ratio="0.8"
					@collectArticle="collectArticle" />
			</div>

			<div class="no-data" v-if="articleList.length === 0">
				暂无数据
			</div>

			<div class="pagination" v-if="total > pageSize">
				<button class="page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">上一页</button>
				<span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
				<button class="page-btn" :disabled="currentPage >= totalPages"
					@click="changePage(currentPage + 1)">下一页</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import ArticleCard from '@/components/card.vue'

	export default {
		name: 'MinePage',
		components: {
			ArticleCard
		},
		data() {
			return {
				activeTab: 'upvote', // upvote: 我点赞的, browse: 我浏览的
				articleList: [],
				currentPage: 1,
				pageSize: 6,
				total: 0,
				phone: ''
			}
		},
		computed: {
			...mapState(['isLogin', 'userInfo']),
			totalPages() {
				return Math.ceil(this.total / this.pageSize)
			}
		},
		mounted() {
			this.phone = localStorage.getItem('phone') || ''
			this.fetchArticleList()
		},
		methods: {
			switchTab(tab) {
				this.activeTab = tab
				this.currentPage = 1
				this.fetchArticleList()
			},

			fetchArticleList() {
				let params = {
					pageNo: this.currentPage,
					pageSize: this.pageSize,
					phone: this.phone
				};
				let apiName = '';
				if (this.activeTab === 'upvote') {
					apiName = 'getUpvoteList';
				} else {
					apiName = 'getBrowseList';
				}
				console.log(`--api.${apiName}参数`);
				console.log(params);
				this.$http[apiName](params).then((res) => {
					console.log(`--api.${apiName}结果`);
					console.log(res)
					if (res.code != 0) {
						this.$message.error(res.message || '获取数据失败')
					} else {
						this.articleList = res.data.rows || []
						this.total = res.data.total || 0
					}
				}).finally(() => {
					// 数据加载完成后，恢复滚动位置
					this.$nextTick(() => {
						document.querySelector('.web-container').scrollTo({
							top: 0,
							behavior: 'smooth'
						});
					})
				});
			},

			changePage(page) {
				if (page < 1 || page > this.totalPages) return
				this.currentPage = page
				this.fetchArticleList()
			},

			handleLogout() {
				this.$confirm('确定要退出登录吗？', '退出登录', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.doLogout();
				}).catch(() => {
					// 用户取消退出
				})
			},
			doLogout() {
			  let params = {
			    phone: this.phone
			  };
			  console.log("--api.zhuxiao--参数");
			  console.log(params);
			  this.$http.zhuxiao(params).then((res) => {
			    console.log("--api.zhuxiao--结果");
			    console.log(res);
			    if (res.code != 0) {
			      this.$message.error(res.msg || `code: ${res.code}`);
			    } else {
			      // 清除localStorage中的用户信息
			      localStorage.removeItem('phone');
			      localStorage.removeItem('token');
			      // 更新Vuex状态
			      this.$store.dispatch('logout');
			      // 跳转到登录页
			      this.$router.push('/login');
			      // 显示退出登录成功提示
			      this.$message.success('已成功退出登录');
			    }
			  });
			}
		}
	}
</script>

<style scoped lang="scss">
	.mine-container {
		width: 100%;
		padding: 40px 16.7vw;
		background-color: #F8F8F8;
	}

	.mine-container-lt {
		width: 300px;

		.user-profile {
			width: 300px;
			padding: 50px 80px 0;
			border-radius: 20px;
			background-color: #FFFFFF;

			.avatar-circle {
				width: 120px;
				height: 120px;
				border-radius: 50%;
				background: linear-gradient(135deg, #6e8efb, #a777e3);
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 40px;
			}

			.avatar-inner {
				width: 100px;
				height: 100px;
				border-radius: 50%;
				background: rgba(255, 255, 255, 0.2);
			}

			.user-info h2 {
				font-size: 24px;
				margin: 0 0 10px 0;
				color: #000;
			}

			.user-info p {
				text-align: center;
				font-size: 16px;
				color: #999;
			}
		}

		.tab-buttons {
			padding: 45px 0 30px;

			.tab-btn {
				width: 276px;
				border-radius: 16px;
				padding: 20px;
				border: none;
				background: none;
				font-size: 16px;
				color: #333;
				cursor: pointer;
				transition: all 0.3s ease;
				position: relative;
			}

			.tab-btn:hover {
				color: #0066FF;
			}

			.tab-btn.active {
				color: #0066FF;
				font-weight: 600;
				background: #F4FAFF;
			}
		}
	}

	.mine-container-rt {
		flex: 1;
		margin-left: 30px;
		min-height: calc(100vh - 130px);

		.data-tip {
			width: 100%;
			height: 65px;
			border-radius: 20px;
			background: #FFFAF1;
			padding: 0 30px;
			font-weight: 500;
			font-size: 16px;
			color: #AE9158;
			line-height: 65px;
			text-align: left;
			margin-bottom: 20px;
		}
	}

	.list-grid {
		display: grid;
		/* 默认最少2列，使用 min() 函数确保列宽不小于360px */
		grid-template-columns: repeat(2, minmax(360px, 1fr));
		gap: 24px;
		justify-items: center;
	}

	/* 中等屏幕：3列布局 */
	@media (min-width: 1280px) {
		.list-grid {
			grid-template-columns: repeat(2, minmax(360px, 1fr));
		}
	}

	/* 大屏幕：4列布局 */
	@media (min-width: 1920px) {
		.list-grid {
			grid-template-columns: repeat(3, minmax(360px, 1fr));
		}
	}

	.no-data {
		text-align: center;
		color: #999;
		font-size: 18px;
	}

	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 20px;
		margin-top: 30px;
	}

	.page-btn {
		padding: 8px 16px;
		border: 1px solid #dcdfe6;
		background: white;
		color: #606266;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s ease;
	}

	.page-btn:hover:not(:disabled) {
		border-color: #409eff;
		color: #409eff;
	}

	.page-btn:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	.page-info {
		color: #606266;
		font-size: 14px;
	}

	.logout-btn {
		display: block;
		width: 300px;
		height: 70px;
		border-radius: 20px;
		background: white;
		color: #333;
		font-size: 18px;
		cursor: pointer;
		transition: all 0.2s ease;
		margin-top: 20px;
		border: none;
	}

	.logout-btn:hover {
		/* border: 2px solid #666; */
	}
</style>